import { render, staticRenderFns } from "./Liquidacion.vue?vue&type=template&id=3b20dfc1"
import script from "./Liquidacion.vue?vue&type=script&lang=js"
export * from "./Liquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports